export default {
    category: {
        cta: "Zobrazit produkty"
    }
}